import React, { useState } from 'react'
import { TopDisplay } from '../../../../ui-components'
import styled from '@emotion/styled';
import { useSettingModal } from '../../../../hooks/Context';
import { CreateClaim,ViewClaim } from '../Modal';
import { UIcon } from '../Modal/CreateAdminUser';
import {IoIosArrowForward as RightIcon} from 'react-icons/io'
import Header from '../../../../customs/Header';

export default function Main() {
  
  const [createClaim, setCreateClaim] = useState(false);

  const handleOpenCreateClaim = () => setCreateClaim(true);
  const handleCloseCreateClaim = () => setCreateClaim(false);

  return (
    <section>
      <Header props={
        { 
          firstName: 'All', 
          secondName: 'Claim', 
          buttonText: 'Create Claim,'
        }}
        handleOpen={handleOpenCreateClaim}
      />
    </section>
  )
}


export const EachClaim = styled.div`
  width:100%;
  padding:10px;
  display: flex;
  justify-content: space-between;
  border:1px solid #E1E1E1;
  border-radius: 5px;
  align-items: center;
  & > div{
    display: flex;
    flex-direction: column;
    gap:10px;
  }
  & > div > div:nth-of-type(2){
    color:#5F6063;
    font-size: 13px;
  }
  & > div > div:first-of-type{
    display:flex;
    gap:20px;
    align-items: center;

  }

  & > div > div:first-of-type > *{
    height:fit-content;
  }
   & > div > div:first-of-type > span:first-of-type{
    display:flex;
    justify-content: center;
    align-items: center;
    width:30px;
    height:30px;
    font-size:15px;
    background-color: #FFF4DE;
    color:#FEB930;
    border-radius: 5px;
   }
   & .name{
    font-weight:500;
   }
   & .Active{
    background-color:#E0FAEE ;
    color:#11643C;
    padding:3px;
    border-radius: 4px;
    font-size:13px
   }
   & .Disabled{
    background-color:#FAE0E0 ;
    color:#DD5151;
    padding:3px;
    border-radius: 4px;
    font-size:13px
   }
`
